module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"formTitle":"Date range"},"de":{"formTitle":"Zeitraum"},"fr":{"formTitle":"Plage de date"},"it":{"formTitle":"Intervallo di date"}}')
  delete Component.options._Ctor
}
